import { DetalhePagamentoResponse } from "../../../../carteira/src/types/detalheResgate/detalhePagamentoResponse";
import { PagamentoResponse } from "../../../../carteira/src/types/detalheResgate/pagamentoResponse";

export const PAGAMENTO = 'PAGAMENTO';
export const DETALHE_PAGAMENTO = 'DETALHE_PAGAMENTO';

export interface PagamentoState {
  Pagamento: DetalhePagamentoResponse[];
  PagamentoDetalhe: DetalhePagamentoResponse[];
}

export interface PagamentoAction {
  type: typeof PAGAMENTO,
  payload: PagamentoResponse[]
}

export interface PagamentoDetalheAction {
  type: typeof DETALHE_PAGAMENTO,
  payload: DetalhePagamentoResponse[]
}

export type PagamentoActionTypes =
  PagamentoAction |
  PagamentoDetalheAction